export enum Routes {
  APP = "APP",
  LOGIN = "LOGIN",
  POSTLOGIN_LANDINGPAGE = "POSTLOGIN_LANDINGPAGE",
  INFORCE_LIFE_DETAIL = "INFORCE_LIFE_DETAIL",
  INFORCE_ANNUITY_DETAIL = "INFORCE_ANNUITY_DETAIL",
  INFORCE = "INFORCE",
  NEW_BUSINESS = "NEW_BUSINESS",
  EXISTING_BUSINESS = "EXISTING_BUSINESS",
  CLIENT = "Client",
  NEW_BUSINESS_CASE_DETAIL="NEW_BUSINESS_CASE_DETAIL",
  EXISTING_POLICIES_NOFEED = "EXISTING_POLICIES_NOFEED",
}
